module.exports = __webpack_public_path__ + "img/Orange_L.b498d714.png";